define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/AggregateController",
	"csi/view",
	"./IncrementSizesMixin",

	"SiteAdmin/ToolbarPluginLocalizedItem"
], function(declare,lang,AggregateController,csiView,IncrementSizesMixin) {

	return declare([AggregateController, IncrementSizesMixin], {

		constructor: function(/*Object*/params) {
			// summary: mixin common action properties
			lang.mixin(this.m_action, {
				bOneRequest: true,
				m_viewRef: this.getAggregateSizesViewRef()
			});

			this.m_action.setReturnParameters();
		},

		getAggregateSizesViewRef: function() {
			return null;
		},

		postProcessSuccess: function() {
			// summary: refresh views and caches as necessary
			var	view = this.widget;

			if (this.m_urlNode == view.getViewURL()) {
				// summary: if on property view, when SizeRange changed, the IncrementDimensions view refresh to update the Increments matrix column and toolbar actions
				var	viewDims = csiView.getView("Dimensions");
				if (viewDims) {
					viewDims.refreshWidget();

					// make sure toolbar is refreshed for new paste operation
					viewDims.postAction();
				}

				this.refNode = null;
				view.refreshWidget(true);
			} else {
				// otherwise just refresh node
				this.bRefreshNode = true;
				this.inherited(arguments);
			}
		}
	});
});